import axios from 'axios'

export const getBlockStreamerInfo = async (streamerName: string) => {
  try {
    const response = await axios.get(
      process.env.NEXT_PUBLIC_BJAPI + `/${streamerName}/station`,
      {withCredentials: true},
    )

    console.log('res BlockUserInfo', response.data)
    return response.data
  } catch (error) {
    console.log(error)
    return error
  }
}
